export default __webpack_public_path__ + "static/media/rmnt0.93385006.jpg";